import React, { useState } from "react";
import Select from "react-select";
import { FiSmile } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css"; 
import NavigateHome from "../../component/utils/NavigateHome";
import PageCount from "../../component/utils/PageCount";

function PersonalityInterests() {
  const [formData, setFormData] = useState({
    personalityType: "",
    hobbies: [],
    interests: [],
    languagesKnown: [],
    fitnessLevel: "",
    travelFrequency: "",
    socialMediaUsage: "",
    musicTaste: "",
    moviePreference: "",
    aboutMe: "",
  });

  const personalityOptions = [
    { value: "introvert", label: "Introvert" },
    { value: "extrovert", label: "Extrovert" },
    { value: "ambivert", label: "Ambivert" },
  ];

  const hobbyOptions = [
    { value: "reading", label: "Reading" },
    { value: "music", label: "Listening to Music" },
    { value: "travel", label: "Traveling" },
    { value: "sports", label: "Sports / Fitness" },
    { value: "art", label: "Art / Painting" },
    { value: "dance", label: "Dance" },
    { value: "cooking", label: "Cooking" },
    { value: "gaming", label: "Gaming" },
  ];

  const interestOptions = [
    { value: "tech", label: "Technology" },
    { value: "fashion", label: "Fashion" },
    { value: "food", label: "Food & Cuisine" },
    { value: "movies", label: "Movies & Shows" },
    { value: "spirituality", label: "Spirituality" },
    { value: "entrepreneurship", label: "Entrepreneurship" },
  ];

  const languageOptions = [
    { value: "english", label: "English" },
    { value: "hindi", label: "Hindi" },
    { value: "marathi", label: "Marathi" },
    { value: "tamil", label: "Tamil" },
    { value: "telugu", label: "Telugu" },
    { value: "gujarati", label: "Gujarati" },
    { value: "other", label: "Other" },
  ];

  const fitnessOptions = [
    { value: "active", label: "Active / Fit" },
    { value: "moderate", label: "Moderately Active" },
    { value: "relaxed", label: "Relaxed Lifestyle" },
  ];

  const travelOptions = [
    { value: "frequent", label: "Frequently" },
    { value: "sometimes", label: "Sometimes" },
    { value: "rarely", label: "Rarely" },
  ];

  const socialMediaOptions = [
    { value: "daily", label: "Daily" },
    { value: "sometimes", label: "Sometimes" },
    { value: "rarely", label: "Rarely" },
    { value: "never", label: "Never" },
  ];

  const musicOptions = [
    { value: "bollywood", label: "Bollywood" },
    { value: "pop", label: "Pop" },
    { value: "classical", label: "Classical" },
    { value: "rock", label: "Rock" },
    { value: "instrumental", label: "Instrumental" },
  ];

  const movieOptions = [
    { value: "romantic", label: "Romantic" },
    { value: "action", label: "Action" },
    { value: "comedy", label: "Comedy" },
    { value: "thriller", label: "Thriller" },
    { value: "documentary", label: "Documentary" },
  ];

  const handleSelectChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Personality & Interests:", formData);
  };

  return (
    <section className="personality-section">
      <PageCount pageName = {"Personality User Info"}/>
      <NavigateHome/>
      <div className="personality-container">
        <div className="text-center mb-4">
          <FiSmile className="header-icon" />
          <h2>Personality & Interests</h2>
          <p>Help others understand your personality, lifestyle & passions ✨</p>
        </div>

        <form className="personality-form" onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-6">
              <label>Personality Type</label>
              <Select
                options={personalityOptions}
                placeholder="Select your personality type"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("personalityType", option?.value)
                }
              />
            </div>

            <div className="col-md-6">
              <label>Fitness Level</label>
              <Select
                options={fitnessOptions}
                placeholder="Select fitness level"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("fitnessLevel", option?.value)
                }
              />
            </div>

            <div className="col-md-6">
              <label>Hobbies</label>
              <Select
                isMulti
                options={hobbyOptions}
                placeholder="Select your hobbies"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("hobbies", option.map((o) => o.value))
                }
              />
            </div>

            <div className="col-md-6">
              <label>Interests</label>
              <Select
                isMulti
                options={interestOptions}
                placeholder="Select your interests"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("interests", option.map((o) => o.value))
                }
              />
            </div>

            <div className="col-md-6">
              <label>Languages Known</label>
              <Select
                isMulti
                options={languageOptions}
                placeholder="Select known languages"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("languagesKnown", option.map((o) => o.value))
                }
              />
            </div>

            <div className="col-md-6">
              <label>Travel Frequency</label>
              <Select
                options={travelOptions}
                placeholder="How often do you travel?"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("travelFrequency", option?.value)
                }
              />
            </div>

            <div className="col-md-6">
              <label>Social Media Usage</label>
              <Select
                options={socialMediaOptions}
                placeholder="How often are you on social media?"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("socialMediaUsage", option?.value)
                }
              />
            </div>

            <div className="col-md-6">
              <label>Music Preference</label>
              <Select
                options={musicOptions}
                placeholder="Favorite music genre"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("musicTaste", option?.value)
                }
              />
            </div>

            <div className="col-md-6">
              <label>Movie Preference</label>
              <Select
                options={movieOptions}
                placeholder="Favorite movie genre"
                classNamePrefix="talaash-select"
                onChange={(option) =>
                  handleSelectChange("moviePreference", option?.value)
                }
              />
            </div>

            <div className="col-12">
              <label>About You</label>
              <textarea
                name="aboutMe"
                placeholder="Write a few lines about your personality and lifestyle..."
                value={formData.aboutMe}
                onChange={handleChange}
                rows={4}
              />
            </div>
          </div>

          <div className="text-center mt-4">
            <button type="submit" className="btn-primary">
              Save & Continue →
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default PersonalityInterests;
